
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tickets",
      function () {
        return require("private-next-pages/[locale]/tickets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tickets"])
      });
    }
  